<template>
    <div class="flex w-full h-screen dark:bg-slate-500 bg-stone-100 relative">
        <Nav :menu="$page.props.menu"></Nav>
        <main class="flex flex-col w-1/2 flex-1 h-screen dark:bg-slate-800 bg-stone-100 relative" >
            <div class="w-full h-12 shadow-sm flex items-center justify-between bg-stone-300 dark:bg-slate-900" :key="$page.url">
                <div class="px-1 py-2">
                    <button class="tailx-btn btn-simple-stone" :class="{
                        'lg:hidden': menuVisible
                    }" @click="store.dispatch('setMenuVisible')">
                        <font-awesome-icon icon="bars" />
                    </button>
                    <span>{{ $page.props.title ?? "" }}</span>
                </div>

                <div class="flex items-center">
                    <div class="dark:text-slate-400 text-stone-600 mr-5 flex justify-center items-center space-x-2">
                        <NavDemandTimer v-if="timerVisible?.id ?? false" />
                        <font-awesome-icon icon="calendar" />
                        <timer :withDate="true" />
                    </div>
                    <button v-if="$page.props.filter || $page.props.custom_filter" class="tailx-btn btn-simple-blue" @click="store.dispatch('setFilterVisible')" title="Filtro">
                        <font-awesome-icon icon="filter" class="fa-lg" />
                    </button>

                    <div class="relative m-6 inline-flex w-fit ">
                        <div v-if="data.notifications.total > 0" class="absolute bottom-auto left-auto right-0 top-0 z-10 inline-block -translate-y-1/2 translate-x-1/2 rotate-0 skew-x-0 skew-y-0 scale-x-[70%] scale-y-[70%] rounded-full bg-pink-700 p-2 text-xs"></div>
                        <button type="button" @click="store.dispatch('setNotificacaoVisible')" class="flex items-center justify-center rounded-lg bg-gray-500 p-1 text-center text-white shadow-lg dark:text-gray-200" title="Notificações">
                            <font-awesome-icon icon="bell"/>
                        </button>
                    </div>
                </div>
            </div>


            <transition
                enter-active-class="transition ease-out duration-300"
                enter-from-class="transform  -translate-x-28"
                enter-to-class="transform  translate-x-0"
                leave-active-class="transition ease-in duration-300"
                leave-from-class="transform  translate-x-0"
                leave-to-class="transform  -translate-x-28"
                appear
                mode="out-in"
            >
                <section class="flex-1 overflow-y-auto">
                    <!-- <flashes :flash="$page.props.flash" :timeout="16000" /> -->
                    <slot></slot>
                </section>
            </transition>
            <div v-if="notificacaoVisible" class="max-w-md overflow-hidden leading-normal rounded-lg absolute top-12 right-3" role="alert">
                <p class="px-3 py-2 font-bold text-white bg-blue-900">
                    Notificações ({{ data.notifications.total }})
                    <button @click="store.dispatch('setNotificacaoVisible')" class="tailx-btn-simple btn-simple-red outline-none ring-0 float-right"><font-awesome-icon icon="circle" /></button>
                </p>
                <div class="w-full max-h-96 px-3 pt-3 pb-1 text-slate-800 bg-stone-200 dark:bg-slate-200 overflow-y-auto">
                    <div v-for="set in data.notifications.data" :key="set.id" class="border-l-2 border-slate-800 leading-none pl-1 mb-4">
                        <small>{{ dayJsFormataData(set.created_at) }}</small>
                        <p class="tracking-tight" v-html="set.data.message"></p>
                    </div>
                </div>
            </div>
            <!-- <Toast :flash="$page.props.flash" :timeout="90000"></Toast> -->
        </main>
        <Filter />
        <Modal />
    </div>
</template>
<script setup>
import { computed, reactive, onMounted } from 'vue'
import NavDemandTimer from '@/Components/Timer/NavDemandTimer.vue';
import { Modal } from 'momentum-modal';
import { usePage } from "@inertiajs/vue3";
import { useStore } from 'vuex'
import Nav from '@/Components/Custom/Nav/Nav.vue'
import Filter from '@/Components/Custom/Filter/Filter.vue'
import Flashes from '@/Components/Custom/Flashes/Flashes.vue'
import Toast from "@/Components/Custom/Alerts/Toast.vue";
import Timer from '@/Components/Timer/Timer.vue'
import { dayJsFormataData } from '@/src/dates';
import SweetAlert from '@/Components/Custom/Alerts/SweetAlert.vue';
import { watch, ref } from 'vue';
import Swal from 'sweetalert2';

const store = useStore()
const filterVisible = computed(() => store.state.filterVisible)
const menuVisible = computed(() => store.state.menuVisible);
const timerVisible = computed(() => store.state.timer.timer)
const notificacaoVisible = computed(() => store.state.notificacaoVisible)
const props = defineProps({
    menu: {
        type: Array,
        default: [
            { label: 'Oficina', icon: 'tools', route: 'workbench.index' },
            { label: 'Areas', icon: 'briefcase', route: 'areas.index' }
        ]
    }
})
const data = reactive({
  notifications: [],
})

watch(usePage().props, (val, old) => {

    if(val.flash.failed){
        Swal.fire({
        title: 'Atenção',
        text: val.flash.failed,
        icon: "warning",
        reverseButtons: true,
        showCancelButton: false,
        allowOutsideClick: val.flash.keyScape,
        allowEscapeKey: val.flash.keyScape,
        confirmButtonText: "OK 👍",
    })

    if(val.flash.success){
        Swal.fire({
        title: 'Concluído',
        text: val.flash.success,
        icon: "success",
        reverseButtons: true,
        showCancelButton: false,
        allowOutsideClick: val.flash.keyScape,
        allowEscapeKey: val.flash.keyScape,
        confirmButtonText: "OK 👍",
    })}

    }
}, { immediate: true })

onMounted(() => {
    axios.get(route('notificacoes'))
    .then(response => {
        data.notifications = response.data
    })
    .catch(error => {
    })
})
</script>
